export default `author {
                image_path
                public_name
                id
                user_id
                slug
                is_seller
            }
        id
        acl_id
        is_high_quality
        average_rating
        total_feedbacks
        title
        slug
        _total
        price
        total_pages,
        sale {
            material_id
            price
            start_at
            expire_at
        }
        is_bundle
        total_bundle_materials
        bundle_price_without_discount
        cover_material_file_id  
        cover_material_file_path {
            plain
            watermarked
        }
`;
